import React from 'react';
import './Highlight.css';

import { makeStyles } from '@material-ui/core/styles';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import ErrorIcon from '@material-ui/icons/Error';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles((theme) => ({
    highlight: {
        paddingLeft: 0,
    },
    highlightIcon: {
        minWidth: 40,
    },

}));

const Highlight = (props) => {
    const classes = useStyles();
    let icon;

    if (props.type === "attention"){
        icon = <EmojiObjectsIcon />; 
    } else if (props.type === "warning"){
        icon = <ErrorIcon />; 
    }

    return (
        <List dense>
            <ListItem alignItems="flex-start" className={classes.highlight}> 
                <ListItemIcon  className={classes.highlightIcon}>
                    {icon}
                </ListItemIcon>
                <ListItemText
                    primary={props.text}
                />
            </ListItem>
        </List>
    );
}

export default Highlight;